/* eslint-disable css-modules/no-unused-class  */
import { useState, FC, useEffect } from 'react';
import classnames from 'classnames';
import { Icon, Search, Tabs } from 'learning-panel-components';
import { translate } from 'translations';
import UserLeaderboardContainer from './userLeaderboardContainer';
import TeamLeaderboardContainer from './teamLeaderboardContainer';
import styles from './leaderboard.module.scss';

const Leaderboard: FC<LeaderboardProps> = (props: LeaderboardProps) => {
    const { onClose, onUnExpand, onlyUsers } = props;
    const [tab, setTab] = useState<number>(TabsType.users);
    const [searchString, setSearchString] = useState<string>('');
    const [showSearchComponent, setShowSearchComponent] = useState<boolean>(false);

    const calcTabs = () => {
        if (onlyUsers) {
            return [{ id: TabsType.users, title: translate('Users') }];
        }
        return [
            { id: TabsType.users, title: translate('Users') },
            { id: TabsType.teams, title: translate('Teams') }
        ];
    };

    return (
        <div className={styles['full-expand-leaderboard']}>
            <div className={styles.wrapper}>
                <div className={styles['search-top']}>
                    {!showSearchComponent && (
                        <div className={styles.top}>
                            <div className={styles.title}>{translate('Leaderboard')}</div>
                            <div className={styles['icons-wrapper']}>
                                <Icon
                                    name="searchIcon"
                                    className={styles['search-icon']}
                                    onClick={() => setShowSearchComponent(true)}
                                />
                                <div
                                    onClick={() => {
                                        onUnExpand(true);
                                    }}
                                >
                                    <Icon data-testid="arrow-icon" name={'unExpandIcon'} className={styles.icon} />
                                </div>
                                <div onClick={() => onClose(false)}>
                                    <Icon data-testid="arrow-icon" name={'close'} className={styles.icon} />
                                </div>
                            </div>
                        </div>
                    )}

                    {showSearchComponent ? (
                        <Search
                            value={searchString}
                            onChange={(val: string) => setSearchString(val)}
                            onReset={() => {
                                setSearchString('');
                                setShowSearchComponent(false);
                            }}
                            arrowIcon
                            noBackground
                        />
                    ) : (
                        <>
                            <div className={styles['tabs-wrapper']}>
                                <Tabs
                                    currentTabId={tab}
                                    onTabClick={(id: number) => {
                                        setTab(id);
                                        setSearchString('');
                                    }}
                                    tabs={calcTabs()}
                                />
                            </div>
                        </>
                    )}
                </div>
                <div className={classnames(styles.content, { [styles['teams-content']]: tab === TabsType.teams })}>
                    {tab === TabsType.users && (
                        <UserLeaderboardContainer
                            isTournament={false}
                            searchString={searchString}
                            key={TabsType.users}
                        />
                    )}
                    {tab === TabsType.teams && (
                        <TeamLeaderboardContainer searchString={searchString} key={TabsType.teams} />
                    )}
                </div>
            </div>
        </div>
    );
};

enum TabsType {
    users,
    teams
}

interface LeaderboardProps {
    onUnExpand: Function;
    onClose: Function;
    onlyUsers?: boolean;
}

export default Leaderboard;
